// extracted by mini-css-extract-plugin
export default {"loginForm":"LoginForm_loginForm__KjLm-","section":"LoginForm_section__dojZt","logo":"LoginForm_logo__5-m+Y","info":"LoginForm_info__W9MX9","footnote":"LoginForm_footnote__RxKit"};